import { render, staticRenderFns } from "./vendorDetail.vue?vue&type=template&id=5c1db068"
import script from "./vendorDetail.vue?vue&type=script&lang=js"
export * from "./vendorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1db068')) {
      api.createRecord('5c1db068', component.options)
    } else {
      api.reload('5c1db068', component.options)
    }
    module.hot.accept("./vendorDetail.vue?vue&type=template&id=5c1db068", function () {
      api.rerender('5c1db068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/vendorDetail.vue"
export default component.exports